import { useEffect, useCallback, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { trackInternalEvent } from '@rio/tracking'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { selectors, actions } from 'builder/modules/resumeEditor'
import { useTailoredDesignation } from 'builder/hooks/useTailoredDesignation'
import { Props } from '../types'

const useGenerateWithTailoredRole = (props: Props) => {
  const { section } = props
  const { recommendedJobTitle, employerName } = useTypedSelector(selectors.jobPostingAPIData)
  const tailoredDesignation = useTailoredDesignation(recommendedJobTitle, employerName)
  const { includeJobPosting } = useTypedSelector(selectors.aiProfile)
  const GenerateWithTailoredRoleRef = useRef<HTMLDivElement | null>(null)
  const dispatch = useDispatch()

  const handleClose = () => {
    dispatch(actions.setIsProfileSummaryWithTailoredResumeModalOpen(false))
  }

  useEffect(() => {
    if (tailoredDesignation) {
      trackInternalEvent('open_ai_writer_tailored_dialog', {
        section,
      })
    }
  }, [section, tailoredDesignation])

  useEffect(() => {
    dispatch(actions.setIsIncludeJobPostingToProfileSummary(true))
  }, [dispatch])

  const handleSelectOption = useCallback(
    (value: boolean) => {
      dispatch(actions.setIsIncludeJobPostingToProfileSummary(value))
    },
    [dispatch],
  )

  const handleGenerate = useCallback(() => {
    dispatch(actions.setIsProfileSummaryWithTailoredResumeModalOpen(false))
    dispatch(actions.generateResumeAiProfileSummary())
    trackInternalEvent('click_generate', {
      label: 'ai_writer_tailored_dialog',
      section,
      position_selected: includeJobPosting,
    })
  }, [dispatch, includeJobPosting, section])

  return {
    tailoredDesignation,
    GenerateWithTailoredRoleRef,
    includeJobPosting,
    handleClose,
    handleSelectOption,
    handleGenerate,
  }
}

export default useGenerateWithTailoredRole
